import { getCountries } from "../api/countryApi";
import { CountryDto, CountryModel } from "../types/common";

export const fetchCountryList = async (): Promise<CountryModel[]> => {
  const rawCountries: CountryDto[] = await getCountries();

  if (!rawCountries) return [];

  return rawCountries.map((country) => ({
    name: country.name.common,
    code: country.cca2,
  }));
};
